import { Instance } from 'mobx-state-tree';
import { RouteTemplatesConstraintLocationDtoModelBase } from './RouteTemplatesConstraintLocationDtoModel.base';

/* The TypeScript type of an instance of RouteTemplatesConstraintLocationDtoModel */
export interface RouteTemplatesConstraintLocationDtoModelType extends Instance<typeof RouteTemplatesConstraintLocationDtoModel.Type> {}

/* A graphql query fragment builders for RouteTemplatesConstraintLocationDtoModel */
export {
  selectFromRouteTemplatesConstraintLocationDto,
  routeTemplatesConstraintLocationDtoModelPrimitives,
  RouteTemplatesConstraintLocationDtoModelSelector,
} from './RouteTemplatesConstraintLocationDtoModel.base';

/**
 * RouteTemplatesConstraintLocationDtoModel
 */
export const RouteTemplatesConstraintLocationDtoModel = RouteTemplatesConstraintLocationDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
